import { ComponentInstall } from "../../utils";
import Button from "./src";

export default ComponentInstall(Button);
